import { create } from "zustand";
const useTooltipStore = create((set, get) => ({
  currentTooltipList: [],
  currentObservedTooltips: {},
  setCurrentTooltipList: tooltip => {
    const currentTooltipListState = get().currentTooltipList;
    const ifTooltipPresent = currentTooltipListState.filter(
      item => item?.id === tooltip.id
    );
    const newTooltipListState = ifTooltipPresent.length // need to handle the case where tooltip is deleted from dom due to route change we need to attach the obeserver again in the component.
      ? [...currentTooltipListState]
      : [...currentTooltipListState, tooltip];
    set({
      currentTooltipList: newTooltipListState
    });
  },
  setCurrentObservedTooltips: tooltipId => {
    set({
      currentObservedTooltips: { tooltipId }
    });
  },
  deleteFromTooltipList: id => {
    let currentTooltipListState = get().currentTooltipList;
    currentTooltipListState = currentTooltipListState.filter(
      tooltip => tooltip?.id !== id
    );
    set({
      currentTooltipList: currentTooltipListState
    });
  },
  deleteFromObservedTooltip: () => {
    set({
      currentObservedTooltips: {}
    });
  },
  resetStore: () => {
    set({
      currentObservedTooltips: {},
      currentTooltipList: []
    });
  }
}));

export default useTooltipStore;
